import { Component } from 'preact'
import { connect } from 'react-redux'
import Paging from './Paging'

import withSearch from '@features/elastic/core/withSearch'

export class PagingContainer extends Component {
	render() {
		const { className, pageNumber, pageSize, totalItems, view, setCurrentPage, ...rest } =
			this.props

		if (!totalItems) return null

		const View = view || Paging

		return View({
			className,
			pageNumber,
			pageSize,
			totalItems,
			onChange: setCurrentPage,
			...rest,
		})
	}
}

const mapStateToProps = state => ({
	pageNumber: state.currentPage?.pagingFilteringContext?.pageNumber,
	pageSize: state.currentPage?.pagingFilteringContext?.pageSize,
	totalItems: state.currentPage?.pagingFilteringContext?.totalItems,
})

export default connect(
	mapStateToProps,
	null,
)(
	withSearch(({ pageNumber, pageSize, totalItems, setCurrentPage }) => ({
		pageNumber,
		pageSize,
		totalItems,
		setCurrentPage,
	}))(PagingContainer),
)
